export const asGermanDateDMY = (date: Date) => {
    return `${formatWithPrefixZero(date.getDate())}.${formatWithPrefixZero(date.getMonth() + 1)}.${date.getFullYear()}`;
};

export const asGermanDateDMYHHMM = (date: Date) => {
    return `${asGermanDateDMY(date)} - ${formatWithPrefixZero(date.getUTCHours())}:${formatWithPrefixZero(date.getUTCMinutes())}`;
};

const formatWithPrefixZero = (value: number) => (value <= 9 ? '0' + value : value.toString());
